var _defs, _path, _text, _text2, _text3, _text4, _text5, _text6, _text7, _text8, _text9, _text10, _text11, _text12, _text13, _text14, _text15;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSepang(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg4136",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 737.73 604.87",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n        font-family: Futura-CondensedMedium, Futura;\n        font-size: 14px;\n        font-weight: 500;\n      }\n\n      .cls-2 {\n        letter-spacing: 0em;\n      }\n\n      .cls-3 {\n        fill: none;\n        stroke: #fff;\n        stroke-linejoin: round;\n        stroke-width: 13.5px;\n      }\n\n      .cls-4 {\n        letter-spacing: -.09em;\n      }\n\n      .cls-5 {\n        letter-spacing: -.06em;\n      }\n\n      .cls-6 {\n        letter-spacing: -.06em;\n      }\n\n      .cls-7 {\n        letter-spacing: -.06em;\n      }\n\n      .cls-8 {\n        letter-spacing: -.02em;\n      }\n\n      .cls-9 {\n        letter-spacing: -.05em;\n      }\n\n      .cls-10 {\n        letter-spacing: -.06em;\n      }\n\n      .cls-11 {\n        letter-spacing: -.04em;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path4146",
    className: "cls-3",
    d: "M348.1,23.64c-6.37-.28-20.77,5.82-74.78,28.25-22.71,9.42-52.25,20.96-65.55,25.57-13.29,4.62-30.65,10.62-38.5,13.39-7.85,2.77-18.56,6.28-23.63,7.75-48.84,14.4-76.44,45.88-81.06,92.32-4.06,40.99,0,56.22,21.88,81.61,17.73,20.59,10.06,37.85-12.37,27.79-22.9-10.25-33.88-8.59-41.54,6.19-6.37,12.37-.74,22.62,12.74,27.7,1.85.92,3.88,1.57,6,1.75,6.28,1.48,13.85,1.94,22.25,1.29,24.65-1.94,116.04-9.69,130.45-11.08,9.51-.92,59.45-4.99,67.85-5.54,4.8-.28,12.09-.92,16.16-1.38,5.91-.65,55.58-4.62,133.86-10.52,3.6-.28,12.46-.92,19.85-1.38,12.56-.83,85.39-6.65,122.32-9.69,41.64-3.42,56.5,2.4,51.33,20.31-4.15,14.4-5.26,14.96-50.68,23.08-18.65,3.32-41.82,7.48-51.42,9.23-9.6,1.75-28.34,5.08-41.54,7.39-13.2,2.31-26.68,4.8-30,5.63-6.65,1.48-25.76,5.08-54.47,10.06-10.43,1.85-20.77,3.69-23.08,4.15s-25.39,4.62-51.24,9.32c-136.63,24.43-207.01,38.8-211.13,43.11-21.79,22.8,26.59,70.35,70.53,69.33,19.57-.46,25.02-2.03,52.16-15.23,53.18-25.76,37.11-31.94,138.94,53.18,15.51,12.92,29.54,24.56,31.3,25.85,1.66,1.29,6.37,4.89,10.43,8.03,4.71,3.69,8.59,5.91,10.71,6.28,1.85.28,3.69.65,4.06.74,14.49,3.42,41.17-39.05,45.42-72.29,4.71-36.74-1.94-50.87-34.16-72.38-16.89-11.26-25.66-18.28-26.5-22.9,0-.74,0-1.48.18-2.12,1.57-3.51,9.42-5.63,23.36-7.57,77.18-10.89,74.41-10.52,148.36-16.06,39.51-2.95,80.41-6.09,90.47-6.92,18.83-1.66,20.96-3.51,28.25-23.26,1.75-4.71,4.62-11.54,6.46-15.23,12.56-25.02,16.89-16.53-44.77-87.06-67.58-77.18-65.36-74.78-74.41-80.04-8.68-5.08-22.34-9.14-29.08-8.59-2.77.28-7.48.65-10.34.92-11.72,1.02-29.17,11.72-39.14,23.91-31.76,38.87-93.06,32.22-112.72-12.19-4.06-9.23-11.17-38.59-17.45-71.64-9.97-53.45-11.45-61.76-11.45-64.72,0-3.51-4.34-10.43-8.49-13.66-1.85-1.48-3.14-2.49-5.63-2.58h0l-.18-.09Z"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(359.34 12.31)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "T"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-2",
    x: 4.57,
    y: 0
  }, "0"), /*#__PURE__*/React.createElement("tspan", {
    x: 10.38,
    y: 0
  }, "4"))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(436.2 200.85)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "T05"))), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(574.56 149.27)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "T06"))), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(721.85 313.38)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "T"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-8",
    x: 4.57,
    y: 0
  }, "0"), /*#__PURE__*/React.createElement("tspan", {
    x: 10.08,
    y: 0
  }, "7"))), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(702.41 388.81)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "T08"))), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(376.27 413)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "T09"))), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(473.38 475.36)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "T"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-9",
    x: 4.57,
    y: 0
  }, "1"), /*#__PURE__*/React.createElement("tspan", {
    x: 9.66,
    y: 0
  }, "0"))), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(417.04 600.92)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "T"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-4",
    x: 4.57,
    y: 0
  }, "1"), /*#__PURE__*/React.createElement("tspan", {
    x: 9.17,
    y: 0
  }, "1"))), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(249.82 493.21)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "T"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-7",
    x: 4.57,
    y: 0
  }, "1"), /*#__PURE__*/React.createElement("tspan", {
    x: 9.53,
    y: 0
  }, "2"))), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(150.93 523.62)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "T"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-5",
    x: 4.57,
    y: 0
  }, "1"), /*#__PURE__*/React.createElement("tspan", {
    x: 9.52,
    y: 0
  }, "3"))), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(64.54 454.52)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "T"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-10",
    x: 4.57,
    y: 0
  }, "1"), /*#__PURE__*/React.createElement("tspan", {
    x: 9.6,
    y: 0
  }, "4"))), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(633.03 316.87)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "T"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-6",
    x: 4.57,
    y: 0
  }, "1"), /*#__PURE__*/React.createElement("tspan", {
    x: 9.5,
    y: 0
  }, "5"))), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(.03 308.33)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "T"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-11",
    x: 4.57,
    y: 0
  }, "0"), /*#__PURE__*/React.createElement("tspan", {
    x: 9.78,
    y: 0
  }, "1"))), _text14 || (_text14 = /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(110.42 297.2)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "T02"))), _text15 || (_text15 = /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(62.35 115.92)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "T03"))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSepang);
export default __webpack_public_path__ + "static/media/sepang.17b4a8d20a153544cc0d5114cb42c0f0.svg";
export { ForwardRef as ReactComponent };